import { Stack, Text } from "@mantine/core";
import { currencyToDhivehiWords } from "@hmh-proc/shared";
import { formatCurrency } from "../utils/currency";
import { dhivehiDisplayStyle } from "../utils/dhivehiText";

type AmountWithDhivehiWordsProps = {
  amount: number | null | undefined;
};

export function AmountWithDhivehiWords({ amount }: AmountWithDhivehiWordsProps) {
  if (amount == null || Number.isNaN(Number(amount))) {
    return <Text size="sm">—</Text>;
  }

  const words = currencyToDhivehiWords(amount);

  return (
    <Stack gap={2}>
      <Text size="sm">{formatCurrency(amount)}</Text>
      <Text size="sm" style={dhivehiDisplayStyle(words)}>
        {words}
      </Text>
    </Stack>
  );
}
